import { render, staticRenderFns } from "./Personalizado.vue?vue&type=template&id=b16f00f8"
import script from "./Personalizado.vue?vue&type=script&lang=js"
export * from "./Personalizado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports